import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

initMain([], {}, []);
header();

function drawCharts() {
    document.querySelectorAll('.google-chart').forEach((el, idx) => {
        drawChart(el.dataset.char, el.getAttribute('id'));
    });
}

function drawChart(charData, id) {
    var data = google.visualization.arrayToDataTable(JSON.parse(charData));

    var options = {
        animation: {
            duration: 300,
            easing: 'out',
            startup: true
        },
        backgroundColor: '#f4f4f4',
        axisTitlesPosition: 'none',
        hAxis: {
            format: 'decimal',
            textPosition: 'none'
        },
        bars: 'horizontal',
        legend: {
            position: 'none'
        },
        chart: {
            title: 'Resultado por regiones'
        },
        colors: ['#c51a1b'],
        fontName: "Open Sans"
    };

    var chart = new google.charts.Bar(document.getElementById(id));

    chart.draw(data, google.charts.Bar.convertOptions(options));
}

google.charts.load('current', {
    'packages': ['bar'],
    'language': 'es-CO'
});
google.charts.setOnLoadCallback(drawCharts);